import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, ROLE_LABELS } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { HiOutlineMail, HiOutlineLockClosed, HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Ingresa email y contraseña');
      return;
    }

    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bienvenido, ${user.full_name}`);
      toast(`Rol: ${ROLE_LABELS[user.role] || user.role}`, { icon: '🔑' });
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al iniciar sesión';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Panel izquierdo - Branding */}
        <div className="login-branding">
          <div className="branding-content">
            <img src="/logo.png" alt="Surtidora M&T" className="login-brand-logo" />
            <h1>Surtidora M&T</h1>
            <p>Sistema de Gestión de Inventario y Ventas</p>
            <div className="branding-features">
              <div className="brand-feature">
                <span>📦</span> Control de inventario en tiempo real
              </div>
              <div className="brand-feature">
                <span>🧾</span> Facturación con NCF (DGII)
              </div>
              <div className="brand-feature">
                <span>📊</span> Reportes y analíticas
              </div>
              <div className="brand-feature">
                <span>🚚</span> Gestión de despacho y entregas
              </div>
            </div>
          </div>
          <div className="branding-footer">
            © {new Date().getFullYear()} Surtidora M&T · República Dominicana
          </div>
        </div>

        {/* Panel derecho - Formulario */}
        <div className="login-form-panel">
          <div className="login-form-wrapper">
            <div className="login-header">
              <img src="/logo.png" alt="Surtidora M&T" className="login-mobile-logo" />
              <h2>Iniciar Sesión</h2>
              <p>Ingresa tus credenciales para acceder al sistema</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Correo electrónico</label>
                <div className="input-wrapper">
                  <HiOutlineMail className="input-icon" />
                  <input
                    id="email"
                    type="email"
                    placeholder="correo@ejemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    autoFocus
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Contraseña</label>
                <div className="input-wrapper">
                  <HiOutlineLockClosed className="input-icon" />
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                  >
                    {showPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={loading}
              >
                {loading ? (
                  <span className="login-spinner"></span>
                ) : (
                  'Iniciar Sesión'
                )}
              </button>
            </form>

            <div className="login-footer-mobile">
              © {new Date().getFullYear()} Surtidora M&T
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
